import {UserAttributes} from "./db/_User";
import {CommentTemplateData} from "@embed/types";

export type GetPaginatedResponse<M> = {
  rows: ReadonlyArray<M>
  count: number
}

export type UserListData = UserAttributes & {
  avatar: string
}

export type UserBlockListData = {
  readonly id: number
  readonly userName: string
  readonly blockTime: Date
}

export type UserFilters = {
  page: number
  sortBy: string
  order: string
  dateStart: string | null
  dateEnd: string | null
  type: ReadonlyArray<string> | null
  tab: 'all' | 'pending' | 'active' | 'blocked'
  searchTerm: string | null
}

export type AdminCommentFilters = {
    readonly sortBy?: string
    readonly order?: string
    readonly tab?: 'all' | 'pending' | 'approved' | 'blocked' | 'flagged' | 'deleted' | 'spammed'
    readonly dateStart?: string
    readonly dateEnd?: string
    readonly issues?: ReadonlyArray<string>
    readonly 'websites[]'?: ReadonlyArray<string>
    readonly page?: number
}

export type AdminCommentsTemplateData = CommentTemplateData & {
  deleted: boolean
  origin: string
}

export type URLFilters = {
  page: number
  sortBy: string
  order: string
}

export type URLItem = {
  name: string
  active: boolean
}

export type WebsiteFilters = {
  page: number
  sortBy: string
  order: string
  tab: string
}

export enum ModerationMode {
  NONE = 'none',
  LIVE_AND_PENDING = 'live_and_pending',
  LIVE_AFTER_APPROVAL = 'live_after_approval'
}

export type WebsiteItem = {
  name: string
  url: string
  disabled: boolean
  moderationMode: ModerationMode
}

export type UpdateWebsiteItem = {
  disabled: boolean
  moderationMode: ModerationMode
  domain: string
}

export type UserAction = {
  type: 'block' | 'unblock' | 'approve' | 'delete'
  ids: ReadonlyArray<number>
}

export type CommentAction = {
  type: 'approve' | 'block' | 'unblock' | 'delete'
  ids: ReadonlyArray<number>
}

export type PendingCountResponse = {
  pendingCount: number
}
